import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

export const inputClass =
  "w-full min-h-12 rounded-xs border border-line bg-white px-4 font-sans text-base " +
  "text-ink placeholder:text-muted-strong transition-colors duration-[160ms] " +
  "focus:border-clay focus:outline-2 focus:outline-clay focus:outline-offset-2 " +
  "aria-[invalid=true]:border-clay";

export function Field({
  id,
  label,
  required,
  error,
  hint,
  className,
  children,
}: {
  id: string;
  label: string;
  required?: boolean;
  error?: string;
  hint?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <label htmlFor={id} className="font-sans text-sm font-medium text-ink">
        {label}
        {required ? (
          <span aria-hidden="true" className="ml-1 text-clay">
            *
          </span>
        ) : null}
      </label>
      {hint ? (
        <p id={`${id}-hint`} className="text-sm text-muted-strong">
          {hint}
        </p>
      ) : null}
      {children}
      {error ? (
        <p id={`${id}-error`} role="alert" className="text-sm text-clay-dark">
          {error}
        </p>
      ) : null}
    </div>
  );
}
